import { lazy, type ComponentType, type LazyExoticComponent } from 'react';
import type { WebModuleDefinition, WidgetLoader, WidgetProps } from './module.js';

const loaders = new Map<string, WidgetLoader>();
const components = new Map<string, LazyExoticComponent<ComponentType<WidgetProps>>>();

/** Called once by the shell with every web module, like the translations. */
export function registerWidgets(modules: WebModuleDefinition[]): void {
  for (const module of modules) {
    for (const [key, loader] of Object.entries(module.widgets ?? {})) loaders.set(key, loader);
  }
}

/** The lazily loaded component of a widget, or null when no web module provides it. */
export function widgetComponent(
  key: string,
): LazyExoticComponent<ComponentType<WidgetProps>> | null {
  const cached = components.get(key);
  if (cached) return cached;
  const loader = loaders.get(key);
  if (!loader) return null;
  const component = lazy(loader);
  components.set(key, component);
  return component;
}
